exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nodata[data-v-1425ec77] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  margin: 1rem 0;\n  font-size: 5rem;\n  width: 100%;\n}\n.nodata .empty[data-v-1425ec77] {\n  width: 5rem;\n  -o-object-fit: cover;\n     object-fit: cover;\n  margin: 2rem 0 0;\n  cursor: default;\n}\n", ""]);

// exports
